<mat-card appearance="outlined" class="calendar-card">
  <div class="calendar-header">
    <p class="calendar-title" [ngClass]="font?.size">{{ monthName }} {{ startDate | date : 'yyyy' }}</p>
  </div>
  <mat-calendar class="calendar no-header" [startAt]="startDate" [dateClass]="dateClass"></mat-calendar>
</mat-card>
